<template>
  <v-menu eager v-model="status" :close-on-click="true" :close-on-content-click="false">
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <img v-on="{ ...tooltip, ...menu }" class="selectionFlag" :src="currentFlag" />
        </template>
        <span>{{ $t("select_language") }}</span>
      </v-tooltip>
    </template>
    <v-card class="selectLang">
      <v-list dense>
        <v-subheader>{{ $t("select_language") }}</v-subheader>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item v-for="(item, i) in supportedLanguage" :key="i" @click="changeLang(item.language)">
            <v-list-item-icon>
              <!--<v-icon v-text="item.icon"></v-icon>-->
              <img class="selectionFlag" :src="item.flag" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.description"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "select-language",
  data() {
    return {
      currentLang: null,
      status: null,
      selectedItem: null,
      currentFlag: null,
    };
  },
  computed: {
    supportedLanguage() {
      return window.supportedLanguage;
    },
  },
  mounted() {
    this.currentLang = window.selectedLanguage;
    this.currentFlag = this.getSelectedFlagImg();
  },
  methods: {
    getSelectedFlagImg() {
      return window.supportedLanguage.filter((lang) => {
        return lang.language === window.selectedLanguage;
      })[0].flag;
    },
    changeLang(newLangId) {
      this.status = false;
      window.selectedLanguage = newLangId;
      this.currentLang = window.selectedLanguage;
      this.currentFlag = this.getSelectedFlagImg();
      this.$vuetify.lang.current = window.selectedLanguage;
      this.$root.$i18n.locale = window.selectedLanguage;
      localStorage.setItem("selectedLanguage", window.selectedLanguage); //set
      window.location.reload();
    },
    getLangDescr(langId) {
      return this.supportedLanguage.find((x) => x.language === langId)
        .description;
    },
  },
};
</script>
<style scoped>
.selectionFlag {
  width: 25px;
  height: 15px;
  cursor: pointer;
}

.selectLang {
  background-color: white;
  margin: 0px;
}
</style>